/**
 * Qué conversación espera que alguien le asigne un asesor.
 *
 * Una sola regla para la Cola global y para el banner de En vivo. El 13-oct-2026
 * En vivo anunciaba «2 conversaciones sin asesor. Filtra por "Sin asignar" para
 * repartirlas» con la Cola global vacía: contaba toda conversación sin dueño, y
 * las dos estaban contestando las preguntas del bot (NEW). Desde DEF-007 el
 * asesor llega al nacer el expediente, así que antes de eso NO tener dueño es lo
 * normal, no un pendiente. Las resueltas de las últimas 24 h también entraban.
 *
 * Puro: lo cruza `test_la_cola_cuenta_lo_que_muestra.py` contra
 * `_ESTADOS_EN_COLA` del servidor, que es lo que cuenta el badge.
 */

// Los MISMOS que cuenta el badge (`_ESTADOS_EN_COLA` en portal_api/handler.py;
// un test los cruza). Hasta el 28-set-2026 esta lista tenía también 'NEW', y
// en NEW contesta el bot: la cola le ofrecía al supervisor repartir
// conversaciones que no necesitan a nadie, y el badge no las contaba.
export const ESTADOS_EN_COLA = ['HUMAN_REQUIRED', 'OPEN']

export interface ConversacionDeCola {
  status: string
  assigned_to?: string | null
  activity?: { is_live?: boolean } | null
}

/** Pide un asesor, no tiene dueño — sin importar la antigüedad. */
export function esperaAsesor(c: ConversacionDeCola): boolean {
  return !c.assigned_to && ESTADOS_EN_COLA.includes(c.status)
}

/** Lo de la cola REAL: además, con actividad en las últimas 24 h. */
export function enLaCola(c: ConversacionDeCola): boolean {
  return esperaAsesor(c) && (c.activity?.is_live ?? true)
}
